import React, { useState } from 'react';
import Button from 'components/Button';
import FormContainer from 'components/LoanForm/FormContainer';
import { ButtonType } from 'components/Button/Button';
import FormNavigation from 'components/FormNavigation';
import { FlowComponentType } from 'routes/types';
import { StudentLoanBookAdvisorResult } from 'enums/StudentLoanForgivenessFlowResults';
import { ConversionType, trackConversion } from 'utils/analytics';
import CalendlyModal from 'components/StudentLoanForgiveness/Modal/CalendlyModal';
import PartnerBanner from 'components/Common/PartnerBanner';

import { ReactComponent as ProfileIcon } from 'images/profile.svg';
import { ReactComponent as PlanIcon } from 'images/plan-icon.svg';

import styles from './BookAdvisor.module.scss';

function BookAdvisor({ navigationInfo, handleNext }: FlowComponentType) {
  const [isScheduleOpen, setScheduleIsOpen] = useState(false);

  const handleSchedule = () => {
    analytics.track('Schedule Consultation Link Opened');
    setScheduleIsOpen(true);
  };

  const onSchedule = () => {
    trackConversion(ConversionType.BookedStudentLoanMeeting);
    setScheduleIsOpen(false);
    handleNext(StudentLoanBookAdvisorResult.Schedule);
  };

  return (
    <>
      <CalendlyModal open={isScheduleOpen} onClose={() => setScheduleIsOpen(false)} onSchedule={onSchedule} />
      <FormNavigation {...navigationInfo} />
      <FormContainer
        video={
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video poster="/student-loan-video-poster.jpg" controls>
            <source src="https://assets.planneryapp.com/media/student-loan-advisor-1.webm" type="video/webm" />
          </video>
        }
        title="Enroll with an Advisor"
        subtitle="Plannery partners with Silver Lion Student Loan Advisors. Schedule a consultation to review your student loans."
      >
        <PartnerBanner name="Silver Lion" logo={<div className={styles.silverLionLogo} />} />

        <div className={styles.advantages}>
          <div className={styles.advantage}>
            <ProfileIcon className={styles.icon} />
            <p className={styles.advantageLabel}>
              Talk to an expert who will help you learn which of the dozens of programs you may benefit from.
            </p>
          </div>
          <div className={styles.advantage}>
            <PlanIcon className={styles.icon} />
            <p className={styles.advantageLabel}>
              Silver Lion can apply on your behalf, appeal if you get rejected, and file annual certifications.
            </p>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button onClick={handleSchedule}>Schedule Consultation</Button>

          <Button type={ButtonType.Inverted} onClick={() => handleNext(StudentLoanBookAdvisorResult.NotNow)}>
            See Other Options
          </Button>
        </div>
      </FormContainer>
    </>
  );
}

export default BookAdvisor;
